import _ from 'lodash'

import {
    ADD_SECTOR_SUCCESS,
    DELETE_SECTOR_SUCCESS,
    EDIT_SECTOR_SUCCESS,
    FETCH_RADAR_SUCCESS,
    REFETCH_DATA_SUCCESS
} from './actionTypes'

const initialState = []

function updateSectorVersions(sectors, affectedSectors) {
    return sectors.map(sector => {
        const affectedSector = _.find(affectedSectors, affectedSector => sector.id === affectedSector.id)

        if (affectedSector) {
            return {
                ...sector,
                version: affectedSector.version
            }
        }

        return sector
    })
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_RADAR_SUCCESS: {
            return payload.sectors
        }
        case REFETCH_DATA_SUCCESS: {
            return payload.sectors
        }

        case ADD_SECTOR_SUCCESS: {
            const { sector, sectorId, placement, affectedSectors } = payload

            const newSectors = state.slice()

            if (sectorId) {
                const selectedSectorIndex = _.findIndex(state, { id: sectorId })

                newSectors.splice(selectedSectorIndex + placement, 0, sector)
            } else {
                newSectors.push(sector)
            }

            return updateSectorVersions(newSectors, affectedSectors)
        }

        case DELETE_SECTOR_SUCCESS: {
            const { deletedSectorId, affectedSectors } = payload

            const newSectors = state.filter(sector => sector.id !== deletedSectorId)

            return updateSectorVersions(newSectors, affectedSectors)
        }

        case EDIT_SECTOR_SUCCESS: {
            return state.map(sector => sector.id === payload.id
                ? { ...sector, ...payload }
                : sector
            )
        }

        default:
            return state
    }
}
